import VueScrollTo from 'vue-scrollto'

export default class ScrollManager {
  constructor() {
    this.isScrolling = false
    this.queue = []
  }

  queueEntryAdd_(func) {
    this.queue.push({ func })
    if (!this.isScrolling) {
      this.queueEntryRun_()
    }
  }

  queueEntryRun_() {
    const entry = this.queue.shift()
    if (!entry) {
      this.isScrolling = false
      return
    }
    this.isScrolling = true
    entry.func()
  }

  queueEntryFinished_() {
    this.queueEntryRun_()
  }

  scrollTo(itemId, duration, opts) {
    opts = Object.assign({}, opts)
    opts.onDone = () => {
      this.queueEntryFinished_()
    }
    this.queueEntryAdd_(() => {
      if (!document.querySelector(itemId)) {
        setTimeout(() => {
          this.queueEntryFinished_()
        })
        return
      }
      VueScrollTo.scrollTo(itemId, duration, opts)
    })
  }
}
